import React from 'react';
import './StubLabel.css';

export const StubLabel = ({ text, className = '', id }) => (
  <span id={id} className={`stubLabel ${className}`}>
    {text}
  </span>
);
